import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray, AbstractControl } from '@angular/forms';
import { MouseEvent } from '@agm/core';
import { RutasService } from '../../../services/rutas.service';
import { EmpleadosServicio } from '../../../services/empleado.service';
import { UploadFilesService } from '../../../services/upload-files.service';
import { ClientesService } from '../../../services/Clientes.service';
import { AlertasModales } from '../../../helpers/alertasModales';
import * as $ from 'jquery/dist/jquery.min.js';
// tslint:disable-next-line:import-blacklist
import { Observable } from 'rxjs';
import { PadronService } from '../../../services/padron.service';
import { Router } from '@angular/router';
import { HostListener} from '@angular/core';

@Component({
  selector: 'app-agregar',
  templateUrl: './agregar.component.html',
  styles: [`

  .ng-invalid.ng-touched:not(form) { border: 1px solid red; }

  `]
})
export class AgregarClienteComponent implements OnInit {
  tiempo = ['dia(s)', 'semana(s)', 'mes(es)', 'año(s)'];
  form: FormGroup;
  msgError: string;
  msgSuccess: string;
  rutas: any = [ ];
  cedula_encontrada = false;
  negocioRequired = false;
  // nivel de zoom de google maps
  zoom: number;

  // posición inicial del centro para el mapa
  lat: number;
  lng: number;
  markers: Marker[] = [];
  loading = false;
  cedulaCliente = '';
  mask: any;
  imgCedula: File;
  dropingFile = false;
  public strRNCCedsinD: string;
  public Ced: string;
  hidePulseBtn = true;
  @ViewChild('imgIdenteficacion') imgIdenteficacion: any;
  private config: Observable<any>;
  constructor(
    private route: Router,
    private _rutasService: RutasService,
    public alerts: AlertasModales,
    private empleadoService: EmpleadosServicio,
    private uploadFileService: UploadFilesService,
    private clienteService: ClientesService,
    private padron: PadronService) {
    this.mask = { mask: '000-0000000-0', len : 13, type: 'num'};
    this.zoom = 8;
    this.lat = 18.6691759;
    this.lng = -71.2512628;
    this.cargarRutas();
    this.initConfig();
  }

  ngOnInit() {
    // Agregar ID del empleado al formulario
    this.initForm();
    const datosNegocio = this.form.get('datosNegocio');
    datosNegocio.get('negocio_nombre').valueChanges
    .subscribe(res => {
      if (res) {
        for (const key of Object.keys(datosNegocio.value)) {
          // tslint:disable-next-line:max-line-length
          if (key === 'negocio_salario' || key === 'negocio_tiempo' || key === 'negocio_actividad' || key === 'negocio_telefono' || key === 'negocio_direccion') {
            datosNegocio.get(key).setValidators(Validators.required);
            datosNegocio.get(key).updateValueAndValidity();
            this.negocioRequired = true;
          }
        }
      } else {
        this.negocioRequired = false;
        for (const key of Object.keys(datosNegocio.value)) {
          datosNegocio.get(key).clearValidators();
        }
      }
    });
  }

  private initForm(): void {
    // Inicializar el formulario de cliente
    this.form = new FormGroup({
      'identificacionCliente': new FormControl('1', Validators.required),
      'foto_perfil': new FormControl(''),
      'fecha_nacimiento': new FormControl('', Validators.required),
      'estado_civil': new FormControl('', Validators.required),
      'cedulaCliente': new FormControl(this.cedulaCliente, Validators.required),
      'nombreCliente': new FormControl('', Validators.required),
      'apellidoCliente': new FormControl('', Validators.required),
      'apodoCliente': new FormControl(''),
      'dependientes': new FormControl(''),
      'vivienda_propia': new FormControl(''),
      'vivienda_alquiler': new FormControl(''),
      'vivienda_tiempo': new FormControl(''),
      'sexoCliente': new FormControl('1', Validators.required),
      'correoCliente': new FormControl(''),
      'telefonoCliente': new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(20)]),
      'celularCliente': new FormControl(''),
      'rutaID': new FormControl('', Validators.required),
      'ID_REFERIDO': new FormControl(''),
      'direccionCliente': new FormControl('', Validators.required),
      'latCliente': new FormControl(''),
      'lngCliente': new FormControl(''),
      'ID_EMPLEADO': new FormControl(this.empleadoService.datosEmpleado.ID_EMPLEADO),
      'platform': new FormControl('desktop'),
      'clienteReferencia': new FormGroup({
        'ID_CLIENTE_REFERENCIA': new FormControl('0'),
        'nombre': new FormControl(''),
        'parentesco': new FormControl(''),
        'telefono': new FormControl('')
      }),
      'referenciasPersonales': new FormArray([]),
      'nombreReferido': new FormControl({value: '', disabled: true}),
      'datosNegocio': new FormGroup({
        'negocio_propio': new FormControl(''),
        'negocio_alquiler': new FormControl(''),
        'negocio_rnc': new FormControl(''),
        'negocio_nombre': new FormControl(''),
        'negocio_local': new FormControl(''),
        'negocio_telefono': new FormControl(''),
        'negocio_direccion': new FormControl(''),
        'negocio_actividad': new FormControl(''),
        'negocio_salario': new FormControl(''),
        'negocio_tiempo': new FormControl(''),
        'negocio_frecuencia_salario': new FormControl('')
      })
    });

    this.config.subscribe(res => {
      if (res.foto_cedula_requerido) {
        this.form.get('foto_perfil').setValidators(Validators.required);
        this.form.get('foto_perfil').updateValueAndValidity();
      }
    });
  }

  // Cargar todas las rutas
  cargarRutas(): void {
    this._rutasService.cargarTodasLasRutas()
    .subscribe(result => { this.rutas = result.rutas; });
  }

  // Agregar un elemente del object cliente.referenciasPersonales
  agregarClienteReferencia() {
    const clienteReferencia = this.form.get('clienteReferencia');
    if (clienteReferencia.get('nombre').value
        && clienteReferencia.get('telefono').value
        && clienteReferencia.get('parentesco').value) {
      (<FormArray>this.form.get('referenciasPersonales')).push(
        new FormControl(this.form.get('clienteReferencia').value)
        );
      this.form.get('clienteReferencia').reset({'parentesco': ''});
    }
  }


  // Remueve un elemente del object cliente.referenciasPersonales
  removerRefPersonalElemento(i) {
    const html =
    `¿Desea eliminar esta referencia?`;
    this.alerts.confirmNgbModal(html, 'Eliminar Referencia')
    .then(resp => {
      if (resp && resp === 'si') {
        (<FormArray>this.form.get('referenciasPersonales')).removeAt(i);
      }
    });
  }

  // Agregar un marker en el mapa de google y asigna las coordenadas lat/lng del cliente
  mapClicked($event: MouseEvent) {
    this.form.get('latCliente').setValue($event.coords.lat);
    this.form.get('lngCliente').setValue($event.coords.lng);
    this.markers = [];

    this.markers.push({
      lat: $event.coords.lat,
      lng: $event.coords.lng,
      draggable: true
    });
  }

  // Envia los datos al servidor para crear un nuevo registro
  async guardarCliente() {
    this.hidePulseBtn = false;
    this.form.markAsUntouched();
    if (this.form.valid) {
      
      this.loading = true;
      if (this.form.get('identificacionCliente').value !== 2) {
        const padron = {
          calle: '',
          casa: '',
          edificio: '',
          telefono: this.form.get('telefonoCliente').value,
          cod_provin: '',
          cod_mun_el: '',
          nombre: this.form.get('nombreCliente').value,
          apellidos: this.form.get('apellidoCliente').value,
          cedula: this.form.get('cedulaCliente').value
        };
        this.padron.registrarCedula(padron).subscribe();
      }
      

      // Subir img de cedula
      let foto_perfil = '';
      if (this.imgCedula) {
        foto_perfil = await this.uploadFileService.uploadCedula(this.imgCedula, this.form.get('cedulaCliente').value)
        .then(res => res).catch(() => this.loading = false);
      }

      this.form.get('foto_perfil').setValue(foto_perfil || '');
      const data = this.form.value;
      data.fecha_nacimiento = data.fecha_nacimiento ? `${data.fecha_nacimiento.year}-${data.fecha_nacimiento.month}-${data.fecha_nacimiento.day}` : '';
      this.clienteService.registrarCliente(data).subscribe(res => {
        this.loading = false;
        if (res) {
          // Restablecer el formulario por default
          (<FormArray>this.form.get('referenciasPersonales')).controls = [];
          this.alerts.agregarClienteModalJquery(this.route, res,
          'CLIENTE CREADO CON EXITO', 'CREAR NUEVO PRESTAMO', 'green', 'modern', 'btn-green');
          this.form.reset();
          this.markers = [];
        }
      }, err => {
        this.loading = false;
        if (err) {
          this.alerts.validacionesModalJquery('Error de validación', err.error, 'red', 'modern');
        }
      });
    } else {
      for (const key of Object.keys(this.form.controls)) {
        this.form.get(key).markAsTouched();
      }
    }
  }

  buscar() {
    this.alerts.busquedaAvanzadaClientesNgbModal().then((res: any) => {
      if (res) {
        this.form.get('nombreReferido').setValue(res.nombre + ' ' + res.apellido);
        this.form.get('ID_REFERIDO').setValue(res.id);
      }
    });
  }

  eliminarReferidoPor() {
    this.form.get('nombreReferido').reset();
    this.form.get('ID_REFERIDO').reset();
  }

  identificacionChange() {
      this.mask =  (this.form.get('identificacionCliente').value === '1' ?
      {mask: '000-0000000-0', len: 13} : '');
    this.form.get('cedulaCliente').markAsUntouched();
    this.form.get('cedulaCliente').setValue('');
    this.form.get('cedulaCliente').updateValueAndValidity();
  }

  cedulaChange(event) {
    this.form.get('cedulaCliente').setValue(event.target.value);
    this.form.get('cedulaCliente').clearValidators();
    if (this.form.get('identificacionCliente').value === '1') {

      this.form.get('cedulaCliente').setValidators([Validators.required, Validators.minLength(13)]);
      if ( this.form.get('cedulaCliente').value.length - 2 === 11) {
      this.searchCedula();
      } else {
        this.form.get('nombreCliente').setValue('');
        this.form.get('apellidoCliente').setValue('');
        this.cedula_encontrada = false;
      }
    } else {
      this.form.get('cedulaCliente').setValidators(Validators.required);
    }
    this.form.get('cedulaCliente').markAsTouched();
    this.form.get('cedulaCliente').updateValueAndValidity();
  }

  loadFile(file: any) {
    // Validar que exista una img
    if (file.files.length > 0 && file.files[0].type.startsWith('image')) {
      this.imgCedula = file.files[0];

      // Cargar un preview de la img seleccionada
      const reader = new FileReader();
      reader.onload = (e: any) => {

        $('#preview').attr('src', e.target.result);
      };
      // tslint:disable-next-line:no-unused-expression
      reader.readAsDataURL(this.imgCedula);
      this.form.get('foto_perfil').setValue(this.imgCedula.name);
    } else {
      this.imgCedula = null;
      $('#preview').attr('src', './assets/img/cedula.png');
    }
  }

  private initConfig(): void {
    this.config = this.clienteService.obtenerConfiguracion();
  }
  searchCedula() {
    if ( this.form.get('identificacionCliente').value === '1') {
      this.padron.getCedula(this.form.get('cedulaCliente').value)
      .subscribe( (res: any) => {
        if (res) {
          this.form.get('nombreCliente').setValue(res.data.nombre);
          this.form.get('apellidoCliente').setValue(res.data.apellidos);
          this.cedula_encontrada = true;
        }
      }, () => {
        this.form.get('nombreCliente').setValue('');
        this.form.get('apellidoCliente').setValue('');
        this.cedula_encontrada = false;
      });
    }
  }

  checkPhones() {
    const telefono = this.form.get('telefonoCliente');
    const celular = this.form.get('celularCliente');
    if (telefono.value.length > 10 ) {
      telefono.clearValidators();
      telefono.setValidators([Validators.required, Validators.minLength(20), Validators.maxLength(20)]);
      telefono.updateValueAndValidity();
    } else {
      telefono.clearValidators();
      telefono.setValidators([Validators.required, Validators.minLength(10), Validators.maxLength(20)]);
      telefono.updateValueAndValidity();
    }


    if (celular.value && celular.value.length < 10 ) {
      celular.clearValidators();
      celular.setValue('');
    } else if (celular.value.length === 10) {
      celular.clearValidators();
      celular.setValidators([Validators.minLength(10), Validators.maxLength(20)]);
      celular.updateValueAndValidity();

    } else {
      celular.clearValidators();
      celular.setValidators([Validators.minLength(20), Validators.maxLength(20)]);
      celular.updateValueAndValidity();
    }
  }

  scrollTop() {
    const options: any = {
      behavior: 'smooth',
      top: 0,
      left: 0,
    };
    this.hidePulseBtn = true;
    window.scrollTo(options);
  }

  tiempoSelectChange(value, forNegocio = true) {
    let tiempo = this.form.get('datosNegocio').get('negocio_tiempo');

    if (!forNegocio) {
      tiempo = this.form.get('vivienda_tiempo');
    }

    if (tiempo.value) {

      const valueSplited = (tiempo.value as string).split(' ');
      tiempo.setValue(
        (typeof parseFloat(valueSplited[0]) == 'number' ? valueSplited[0] : 1) + ` ${value}`
      );

    } else {
      tiempo.setValue(`1 ${value}`);
    }

  }

  tiempoInputChange(value, forNegocio = true) {
    let tiempo = this.form.get('datosNegocio').get('negocio_tiempo');
    
    if (!forNegocio) {
      tiempo = this.form.get('vivienda_tiempo');
    }

    if (tiempo.value) {

      const valueSplited = (tiempo.value as string).split(' ');
      tiempo.setValue(
        value + ` ${valueSplited.length == 2 ? valueSplited[1] : valueSplited[0]}`
      );

    } else {
      tiempo.setValue(value + ` ${this.tiempo[2]}`);
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (!this.hidePulseBtn) {
      this.hidePulseBtn = true;
    }
  }
}

// just an interface for type safety.
interface Marker {
 lat: number;
 lng: number;
 label?: string;
 draggable: boolean;
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/clientes/agregar/agregar.component.ts